/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q1_CInputs */

const en_consult_q1_c = /** @type {(inputs: Consult_Q1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still an idea or exploring`)
};

const id_consult_q1_c = /** @type {(inputs: Consult_Q1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih ide atau eksplorasi`)
};

/**
* | output |
* | --- |
* | "Still an idea or exploring" |
*
* @param {Consult_Q1_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q1_c = /** @type {((inputs?: Consult_Q1_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q1_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q1_c(inputs)
	return en_consult_q1_c(inputs)
});